import { render, staticRenderFns } from "./BuyingListDetail.vue?vue&type=template&id=09e64081&scoped=true"
import script from "./BuyingListDetail.vue?vue&type=script&lang=ts"
export * from "./BuyingListDetail.vue?vue&type=script&lang=ts"
import style0 from "./BuyingListDetail.vue?vue&type=style&index=0&id=09e64081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e64081",
  null
  
)

export default component.exports